"use strict";
// tslint:disable:variable-name
Object.defineProperty(exports, "__esModule", { value: true });
function createNumericalSolutionResult(result, errorText) {
    if (errorText === void 0) { errorText = ""; }
    return {
        Result: result,
        ErrorText: errorText,
    };
}
function solve(rootFunction, lowerLimit, upperLimit, errorTolerance) {
    var a = lowerLimit;
    var b = upperLimit;
    var c = 0;
    var d = Number.MAX_VALUE;
    var fa = rootFunction(a);
    var fb = rootFunction(b);
    if (isNaN(fa) || isInfinity(fa)) {
        return createNumericalSolutionResult(null, "Brentsmethod: the provided function did not return a valid value for a");
    }
    //throw new Exception("Brentsmethod: the provided function diod not return a valid value for a");
    if (isNaN(fb) || isInfinity(fb)) {
        return createNumericalSolutionResult(null, "Brentsmethod: the provided function did not return a valid value for b");
    }
    //throw new Exception("Brentsmethod: the provided function diod not return a valid value for b");
    var fc = 0;
    var s = 0;
    var fs = 0;
    // if f(a) f(b) >= 0 then error-exit
    //if (fa*fb >= 0)
    if (fa * fb > 0) {
        //if (fa < fb)
        //  return a;
        //else
        //  return b;
        return createNumericalSolutionResult(null, "Root is not bracketed");
        //throw new Exception("Root is not bracketed");
    }
    // if |f(a)| < |f(b)| then swap (a,b) end if
    if (Math.abs(fa) < Math.abs(fb)) {
        var tmp = a;
        a = b;
        b = tmp;
        tmp = fa;
        fa = fb;
        fb = tmp;
    }
    c = a;
    fc = fa;
    var mflag = true;
    var i = 0;
    while (!(fb === 0) && (Math.abs(a - b) > errorTolerance)) {
        if ((fa !== fc) && (fb !== fc)) {
            // Inverse quadratic interpolation
            s = a * fb * fc / (fa - fb) / (fa - fc) + b * fa * fc / (fb - fa) / (fb - fc) + c * fa * fb / (fc - fa) / (fc - fb);
        }
        else {
            // Secant Rule
            s = b - fb * (b - a) / (fb - fa);
        }
        var tmp2 = (3 * a + b) / 4;
        if ((!(((s > tmp2) && (s < b)) || ((s < tmp2) && (s > b)))) ||
            (mflag && (Math.abs(s - b) >= (Math.abs(b - c) / 2))) || (!mflag && (Math.abs(s - b) >= (Math.abs(c - d) / 2)))) {
            s = (a + b) / 2;
            mflag = true;
        }
        else {
            if ((mflag && (Math.abs(b - c) < errorTolerance)) || (!mflag && (Math.abs(c - d) < errorTolerance))) {
                s = (a + b) / 2;
                mflag = true;
            }
            else {
                mflag = false;
            }
        }
        fs = rootFunction(s);
        d = c;
        c = b;
        fc = fb;
        if (fa * fs < 0) {
            b = s;
            fb = fs;
        }
        else {
            a = s;
            fa = fs;
        }
        // if |f(a)| < |f(b)| then swap (a,b) end if
        if (Math.abs(fa) < Math.abs(fb)) {
            var tmp = a;
            a = b;
            b = tmp;
            tmp = fa;
            fa = fb;
            fb = tmp;
        }
        i++;
        if (i > 1000) {
            return createNumericalSolutionResult(null, "Brent's method could not find a solution, error is " + fb);
        }
        //throw new Exception(string.Format("Brent's method could not find a solution, error is {0}", fb));
    }
    return createNumericalSolutionResult(b); // b;
}
exports.solve = solve;
function isInfinity(value) {
    return value === Number.POSITIVE_INFINITY || value === Number.NEGATIVE_INFINITY;
}
